import React from "react";

export const PanelTemplate = ({children, id}) => {
    return (
        <section id={id} className="wrapper">
            {children}
        </section>
    );
}

export default PanelTemplate;
